export default "__VITE_PUBLIC_ASSET__21b8f063__"